import { useEffect } from 'react';
import useFetch from 'hooks/useFetch';
import { getCollections } from 'data/api';
import { transformCollectionsResponse } from 'data/api/transformers/response';

const useFetchCollections = userId => {
  const {
    fetch: fetchCollections,
    transformedData: collectionsData,
    isLoading,
    error
  } = useFetch(getCollections, transformCollectionsResponse);
  useEffect(() => {
    if (!userId) return;
    fetchCollections({
      userId
    });
  }, [fetchCollections, userId]);
  return {
    collectionsData,
    isLoading,
    error
  };
};

export default useFetchCollections;